export const SPOTIFY_SCOPE = 'playlist-read-private playlist-read-collaborative';
export const REDIRECT_URI = `${window.location.origin}/callback/spotify`;

export interface SpotifyPlaylist {
  id: string;
  name: string;
  uri: string;
  images: Array<{ url: string }>;
}

export interface TokenResponse {
  access_token: string;
  refresh_token?: string;
  expires_in: number;
  token_type: string;
}

// PKCE Helper Functions
export const generateCodeVerifier = (length: number) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export const generateCodeChallenge = async (verifier: string) => {
  const data = new TextEncoder().encode(verifier);
  const digest = await window.crypto.subtle.digest('SHA-256', data);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(digest)]))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

// Token Management
export const storeTokens = (accessToken: string, refreshToken?: string, expiresIn?: number) => {
  localStorage.setItem('spotify_access_token', accessToken);
  if (refreshToken) {
    localStorage.setItem('spotify_refresh_token', refreshToken);
  }
  if (expiresIn) {
    const expirationTime = Date.now() + expiresIn * 1000;
    localStorage.setItem('spotify_token_expiration', expirationTime.toString());
  }
};

export const getStoredTokens = () => ({
  accessToken: localStorage.getItem('spotify_access_token'),
  refreshToken: localStorage.getItem('spotify_refresh_token'),
  expirationTime: Number(localStorage.getItem('spotify_token_expiration')),
});

export const isTokenExpired = () => {
  const { expirationTime } = getStoredTokens();
  return !expirationTime || Date.now() > expirationTime;
};

export const getTokensFromHash = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    code: params.get('code'),
    state: params.get('state')
  };
};
